/**
 * Column component
 * @returns <Column />
 */

const Column = ({ columns, boxes }) => {
    // console.log(boxes);

    return (
        <div className="columns">
            <div className="wrapper">
                <div className={`columns__content ${columns ? "--" + columns + "-columns" : "--3-columns"}`}>
                    {boxes?.map((box, i) => {
                        return (
                            <div className="columns__box" key={i}>
                                <div className="columns__box__container">
                                    <h4 className="columns__box__title">{box.title}</h4>

                                    <p className="columns__box__description">{box.description}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Column